import { render, staticRenderFns } from "./AdviserFaqs.vue?vue&type=template&id=259ff0c7&scoped=true"
import script from "./AdviserFaqs.vue?vue&type=script&lang=js"
export * from "./AdviserFaqs.vue?vue&type=script&lang=js"
import style0 from "./AdviserFaqs.vue?vue&type=style&index=0&id=259ff0c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ff0c7",
  null
  
)

export default component.exports